export default {
  countryCode: 'DE',
  regionLinks: [
    {
      title: 'Munich',
    },
  ],
};
